

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class PaymentFeeTemplate_ManagedObject

class PaymentFeeTemplate_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Relationship: lines
    protected _lines:MIOManagedObjectSet = null;
    get lines():MIOManagedObjectSet {
        return this.valueForKey('lines');
    }
    addLinesObject(value:PaymentFeeTemplateLine) {
        this._addObjectForKey(value, 'lines');
    }
    removeLinesObject(value:PaymentFeeTemplateLine) {
        this._removeObjectForKey(value, 'lines');
    }
}
